<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">溯源信息设定</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input
            v-model="selectVal"
            @on-search="search()"
            search
            placeholder="输入字段标题"
          />
        </div>
        <div class="select" style="line-height: 35px">
          共 {{ allPage }} 条记录
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
        <Table
          border
          :columns="columns"
          :data="pageData"
          style="width: 100%"
          v-if="pageData.length !== 0"
        >
          <!-- <Table border :columns="columns" :data="datas" style="width:100%;"> -->
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">修改</Button>
            <Button type="error" @click="remove(index)">删除</Button>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer
        title="修改溯源信息"
        :closable="false"
        v-model="value"
        width="600"
      >
        <updataFiled
          :datas="pageData[index]"
          @results="updataFileds"
        ></updataFiled>
      </Drawer>
      <Drawer
        title="添加溯源字段"
        :closable="false"
        v-model="addVal"
        width="600"
      >
        <NewFiled @change="addClientList" @close="NewFiledClose"></NewFiled>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewFiled from "@/views/filedList/newFiled";
import updataFiled from "@/views/filedList/updataFiled";
import { GetFiledList, DelFiledList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "字段ID",
          key: "id",
          width: 100,
        },
        {
          title: "企业代码",
          key: "clientCode",
          width: 120,
        },
        {
          title: "字段类型",
          key: "dataType",
          width: 120,
        },
        {
          title: "字段标题",
          key: "title",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: "添加时间",
          key: "time",
          width: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      datas: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      index: "",
    };
  },
  components: {
    NewFiled,
    updataFiled,
  },
  beforeCreate() { },
  mounted() { },
  watch: {},
  created() {
    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
    this.getFileds();
  },
  methods: {
    search() {
      this.getFileds();
    },
    getFileds() {
      // 获取溯源资料
      GetFiledList({
        page: this.pages,
        pagesize: 10,
        name: this.selectVal,
      }).then((res) => {
        this.datas = res;
        // 初始列表过滤10
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },
    NewFiledClose() {
      this.addVal = false;
      this.$message({
        type: "success",
        message: "添加成功!",
      });
      this.getFileds();
    },
    updataFileds(value) {
      this.value = false;
      this.getFileds();
    },
    inAddVal(index) {
      this.addVal = true;
    },
    show(index) {
      this.index = index;
      this.value = true;
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getFileds();
    },
    // 接收来自子组件的回值---添加信息
    async addClientList(value) {
      this.datas.push(value);
    },
    // 删除按钮
    remove(index) {
      const title = this.pageData[index].title;
      const code = this.pageData[index].clientCode;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除该" + title + "字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelFiledList({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.getFileds();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
